import React, { useEffect, createContext, useState } from 'react'
import { Route } from 'react-router-dom'
import { firebase } from './config/firebase'
import ScrollToTop from './ui/ScrollToTop/ScrollToTop'
import { SiteToastProvider } from './ui/SiteToast/SiteToastContext'
import Auth from './pages/Auth/Auth'
import getCollection from './utils/db/getCollection'

export const AuthContext = createContext({ user: null, pageTitle: 'Title' })

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [cities, setCities] = useState(null)
  const [pageTitle, setPageTitle] = useState('Title')

  useEffect(() => {
    const userStateListener = firebase.auth().onAuthStateChanged(setUser)
    getCollection({ path: 'cities', docIdName: 'id' }).then((docs) => setCities(docs))
    return () => {
      userStateListener()
    }
  }, [])

  return <AuthContext.Provider value={{ user, cities, pageTitle, setPageTitle }}>{children}</AuthContext.Provider>
}

function App() {
  return (
    <SiteToastProvider>
      <AuthProvider>
        <ScrollToTop />
        <Route path="/" component={Auth} />
      </AuthProvider>
    </SiteToastProvider>
  )
}

export default App
